import { UntitledIcon } from '@faceup/icons'
import { ulDotsVertical } from '@faceup/icons/ulDotsVertical'
import { Button, type ButtonProps, Dropdown, type DropdownProps } from '@faceup/ui-base'
import { useContext } from 'react'
import { UiContext } from '../UiProvider/UiProvider'

type MoreOptionsProps = DropdownProps & {
  buttonProps?: Omit<ButtonProps, 'children' | 'icon' | 'label'>
}

export const MoreOptions = ({ buttonProps, ...props }: MoreOptionsProps) => {
  const { moreOptions } = useContext(UiContext)

  return (
    <Dropdown placement='bottomRight' {...props}>
      <Button
        label={moreOptions?.label ?? 'More options'}
        icon={<UntitledIcon icon={ulDotsVertical} />}
        data-onboarding='more-options-button'
        {...buttonProps}
      />
    </Dropdown>
  )
}
